module.exports = "/images/icon_social_tw.png?1eea726267a0b5329a91ce364d70e704";